import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AlyceTheme } from '@alycecom/ui';

const useStyles = makeStyles<AlyceTheme, { image: string }>({
  image: {
    backgroundImage: props => `url(${props.image})`,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
});

export interface IAlyceLogoProps {
  image: string;
}

const AlyceLogo = ({ image }: IAlyceLogoProps): JSX.Element => {
  const classes = useStyles({ image });
  return (
    <Box
      width={[82, 120]}
      ml={[2, 0]}
      display="flex"
      justifyContent="center"
      alignItems="center"
      data-testid="AlyceLogo"
    >
      <Box className={classes.image} width={[82, 120]} height={[36, 64]} />
    </Box>
  );
};

export default AlyceLogo;
